import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export function useKeyboardNavigation() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleKeyPress = (e: KeyboardEvent) => {
      // Only trigger if Alt/Option key is pressed with the shortcut
      if (!e.altKey) return;

      switch (e.key) {
        case 'd':
          navigate('/dashboard');
          break;
        case 'c':
          navigate('/contracts');
          break;
        case 'p':
          navigate('/proposals');
          break;
        case 'm':
          navigate('/marketplace');
          break;
        case 'a':
          navigate('/analytics');
          break;
        case 'h':
          navigate('/');
          break;
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [navigate]);
}